import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { SecondaryButton } from 'components/buttons'
import { openReservationModal } from 'registry/modals/actions'
import * as css from './guest-actions.scss'

const NotReservedAction = ({ onClick, buttonStyle, regItem }, context) => {
  if (regItem.disableReservations) return null
  return (
    <SecondaryButton
      pill
      {...buttonStyle}
      className={css.guestAction}
      onClick={onClick}
      rel="nofollow"
      size={context.isMobile ? 'small' : undefined}
    >
      Give This Gift
    </SecondaryButton>
  )
}

NotReservedAction.propTypes = {
  buttonStyle: PropTypes.object,
  regItem: PropTypes.shape({
    registryId: PropTypes.number.isRequired,
  }).isRequired,
  isMobile: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
}

NotReservedAction.contextTypes = {
  isMobile: PropTypes.bool,
}

NotReservedAction.defaultProps = {
  buttonStyle: {},
}

const mapDispatchToProps = (dispatch, { regItem }) => ({
  onClick: () => dispatch(openReservationModal(regItem)),
})

export default connect(null, mapDispatchToProps)(NotReservedAction)
